import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";


import { WelcomeForm } from "./components/welcome-form";
import { useWelcomeStepQuery } from "./hooks/use-welcome-step-query";
import { WelcomeFormSchema, welcomeFormSchema } from "./schema";
import { useWelcomeFormStore } from "./store/use-welcome-form-store";

export default function OnboardingPage() {
  const { data } = useWelcomeFormStore();

  const methods = useForm<WelcomeFormSchema>({
    mode: "onChange",
    resolver: zodResolver(welcomeFormSchema),
    defaultValues: { ...data },
  });

  const { step, submit, nextStep, previousStep } = useWelcomeStepQuery();

  return (
    <div className="relative h-full w-full">

      <FormProvider {...methods}>
        <div className="relative flex h-full w-full mt-10 flex-col justify-between px-4">
      {/* <WelcomeProgress currentStep={step} totalSteps={13} className="absolute" /> */}

          <WelcomeForm
            activeStep={step}
            nextStep={nextStep}
            previousStep={previousStep}
            submit={submit}
          />
        </div>
      </FormProvider>
    </div>
  );
}
